import React from "react";
import { Card, Typography, LinearProgress, Box, useTheme } from "@mui/material";
import ColoredLogo from "../misc/ColoredLogo";

const SkillCard = ({ logoSrc, skillName, description, progress }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        padding: 2,
        maxWidth: 400,
      }}
    >
      <Box
        sx={{
          width: "150px",
          display: "flex",
          justifyContent: "center",
          mr: 2,
        }}
      >
        <ColoredLogo
          src={logoSrc}
          alt={`${skillName} logo`}
          color={theme.palette.mode === "dark" ? "#ddd" : "#333"}
          sx={{ width: "100%", maxWidth: "250px", height: "auto" }}
        />
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="h6">{skillName}</Typography>
        <Typography variant="caption" color="text.secondary">
          {description}
        </Typography>
        <Box sx={{ position: "relative", mt: 1 }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 10,
              borderRadius: 5,
              backgroundColor: "rgba(0, 0, 0, 0.3)",
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "0.75rem",
              mt: 0.5,
            }}
          >
            <Typography variant="caption" sx={{ opacity: 0.25 }}>
              Junior
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.25 }}>
              Senior
            </Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default SkillCard;
